<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="orders"
      class="mt-1"
      hide-default-footer
      :loading="loading"
    >
      <template v-slot:item="props">
        <tr>
          <td>{{ props.item.title }}</td>
          <td>
            <a @click="viewItem(props.item)">{{ props.item.order_number }}</a>
          </td>
          <td>{{ props.item.operator_id.substring(0, 15) + "..." }}</td>
          <td>
            <span
              v-if="props.item.status === 'ongoing'"
              class="blue--text font-weight-medium"
              >Ongoing</span
            >
            <span
              v-else-if="props.item.status === 'opened'"
              class="grey--text font-weight-medium"
              >Opened</span
            >
            <span
              v-else-if="props.item.status === 'reopened'"
              class="orange--text font-weight-medium"
              >Reopened</span
            >
            <span
              v-else-if="props.item.status === 'resolved'"
              class="orange--text font-weight-medium"
              >Resolved</span
            >
            <span
              v-else-if="props.item.status === 'rejected'"
              class="red--text font-weight-medium"
              >Rejected</span
            >
            <span
              v-else-if="props.item.status === 'closed'"
              class="green--text font-weight-medium"
              >Closed</span
            >
            <span v-else>{{ props.item.status }}</span>
          </td>
          <td class="justify-center layout px-0">
            <v-icon @click="viewItem(props.item)">visibility</v-icon>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>No data</template>
    </v-data-table>
  </v-card>
</template>

<script>
import fb from "@/firebase";

export default {
  name: "ProfileOrders",
  components: {},
  currentItem: {},
  props: {
    uid: String
  },
  data: () => ({
    orders: [],
    loading: false,
    currentProfile: "",
    headers: [
      { text: "Type", value: "title", sortable: false },
      { text: "Order number", value: "order number", sortable: false },
      { text: "Operator", value: "operator id", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Actions", value: "name", sortable: false, align: "center" }
    ]
  }),
  methods: {
    createItem: function() {
      this.modal.payload = {};
    },
    viewItem: function(item) {
      this.modal.payload = Object.assign({}, item);
    }
  },
  mounted: function() {
    this.currentProfile = this.uid;
  },
  watch: {
    currentProfile: function(val) {
      fb.db
        .collection("stripe_customers")
        .doc(`${val}`)
        .collection("orders")
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let order = doc.data();
            order.id = doc.id;
            this.orders.push(order);
          });
        });
    }
  }
};
</script>
